import React, { useEffect, useState } from "react";
import Filescan from "../Filescan/filescanList.js";
import Header from "../common/Header/Header";
import Banner from "../common/Banner/Banner";
import { MS_CONSOLE_TITLE } from "../utils/Constants";
import "../../Components/common/css/AdminPage.css";
import { useLocation, useNavigate } from 'react-router-dom';
import TrackOwnerData from "./TrackOwnerData.js";
import LiveUrlTrackingList from "./LiveUrlTracking/LiveUrlTrackingList";
import LiveUrlTrackingErrorBoundary from "./LiveUrlTracking/LiveUrlTrackingErrorBoundary";
import RuntimeConfigPanel from "./RuntimeConfig/RuntimeConfigPanel";
import RuntimeConfigErrorBoundary from "./RuntimeConfig/RuntimeConfigErrorBoundary";
 
const AdminPage = () => {
  const msTitle = `${MS_CONSOLE_TITLE} - Admin Dashboard`;
  const location = useLocation();
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState("filescan");
  const [disableCheckbox, setDisableCheckbox] = useState(true);
  const isSuperAdmin = localStorage.getItem('user.role') === 'Super Admin';
  let currentPath = location.pathname;

  useEffect(() => {
    const role = localStorage.getItem('user.role');
    if (!['Super Admin', 'Admin'].includes(role)) {
      navigate('/mdc/auth/media');
    }
  }, [navigate]);
 
 
  const renderSection = () => {
    switch (activeSection) {
      case "filescan":
        return <Filescan />;
      case "trackownerdata":
        return <TrackOwnerData />;
      case "liveurltracking":
        return (
          <LiveUrlTrackingErrorBoundary>
            <LiveUrlTrackingList />
          </LiveUrlTrackingErrorBoundary>
        );
      case "runtimeconfig":
        return (
          <RuntimeConfigErrorBoundary>
            <RuntimeConfigPanel />
          </RuntimeConfigErrorBoundary>
        );
      default:
        return <Filescan />;
    }
  };
 
  return (
    <div>
      <Header title={msTitle} />
      <Banner title={msTitle} currentPath={currentPath} disableCheckbox={disableCheckbox} />
 
      <div className="admin-menu">
        <button
          onClick={() => setActiveSection("filescan")}
          className={activeSection === "filescan" ? "active" : ""}
        >
          File Scan
        </button>

        <button
          onClick={() => setActiveSection("trackownerdata")}
          className={activeSection === "trackownerdata" ? "active" : ""}
        >
          User Activity History
        </button>

        <button
          onClick={() => setActiveSection("liveurltracking")}
          className={activeSection === "liveurltracking" ? "active" : ""}
        >
          Live URL Tracking
        </button>

        {isSuperAdmin && (
          <button
            onClick={() => setActiveSection("runtimeconfig")}
            className={activeSection === "runtimeconfig" ? "active" : ""}
            data-testid="runtimeconfig-tab"
          >
            Runtime Config
          </button>
        )}
      </div>
 
      <div className="admin-content">
        {renderSection()}
      </div>
    </div>
  );
};
 
export default AdminPage;
